import { useEffect, useMemo, useState } from "react";

import Form from 'react-bootstrap/Form';
import Container from "react-bootstrap/Container";
import Badge from "react-bootstrap/Badge";
import {toast} from "react-toastify";

import {getUsers, updateUser} from "../../services/UserService";
import Table from "../../components/Table";
import { Roles } from "../../utils/constants";

const UsersList = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    getUsers().then((data) => setUsers(data));
  }, []);

  const updateVerificationStatus = (userId, isVerified) => {
    updateUser({ id: userId, is_verified: isVerified })
        .then((data) => {
          setUsers((oldUsers) => oldUsers.map((user) => {
            if (user.id === userId) {
              return data;
            }
            return user;
          }))
          toast.success(`The user has been ${isVerified ? 'verified' : 'unverified'}.`);
        });
  }

  const columns = [
    {
      label: "First name",
      name: "first_name",
    },
    {
      label: "Last name",
      name: "last_name",
    },
    {
      label: "E-mail",
      name: "email",
    },
    {
      label: "Phone number",
      name: "phone_number",
    },
    {
      label: "Verification",
      name: "is_verified",
      component: (item) => {
        const bg = item.is_verified ? "success" : "danger";

        return (
          <Container>
            <Badge bg={bg} style={{ color: "white", margin: "auto" }}>
              <Form.Check
                disabled={item.role === Roles.ADMIN.value}
                checked={item.is_verified}
                onChange={() => updateVerificationStatus(item.id, !item.is_verified)}
                type="switch"
                id="disabled-custom-switch"
              />
            </Badge>
          </Container>
        );
      },
    },
    {
      label: "Role",
      name: "role",
      component: (item) => (
        <Container>
          <Badge bg="secondary" style={{ color: "white", margin: "auto" }}>
            {item?.role}
          </Badge>
        </Container>
      ),
    },
  ];

  const employeesCount = useMemo(() => {
    return users
      ? users.filter((user) => user.role === Roles.EMPLOYEE.value).length
      : 0;
  }, [users]);

  const employersCount = useMemo(() => {
    return users
      ? users.filter((user) => user.role === Roles.EMPLOYER.value).length
      : 0;
  }, [users]);

  const verifiedAccountsCount = useMemo(() => {
    return users ? users.filter((user) => user.is_verified).length : 0;
  }, [users]);

  return (
    <div>
      <div>
        <h5>Total Accounts: {users ? users.length : 0}</h5>
        <h6>Verified Accounts: {verifiedAccountsCount}</h6>
        <h6>Employers: {employersCount}</h6>
        <h6>Employees: {employeesCount}</h6>
      </div>
      <Table columns={columns} data={users} />
    </div>
  );
};

export default UsersList;
